<ng-container *transloco="let t;">
    <div class="position-relative">
        <label class="col-form-label p-0" for="currency">{{ field.label }}</label>
        <ng-select [items]="allCurrencies" bindLabel="label" bindValue="value" 
                   [formControl]="formGroup.get('currency')"
                   [readonly]="!canEdit"
                   searchable="true" placeholder="Select currency" 
                   (change)="onCurrencyChange($event?.value || $event)"> 
        </ng-select>
    </div>
</ng-container>
